function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import { children, optional, once } from '../Composite';
import Label from '../Label';
import Input from '../Input';
import InputAreaWithLabelComposite from '../Composite/InputAreaWithLabelComposite/InputAreaWithLabelComposite';

var TextField = function TextField(_ref) {
  var props = _objectWithoutProperties(_ref, []),
      children = _ref.children;

  return React.createElement(
    InputAreaWithLabelComposite,
    props,
    children
  );
};

TextField.propTypes = {
  children: children(optional(Label), once(Input))
};

TextField.displayName = 'TextField';

export default TextField;
//# sourceMappingURL=TextField.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/TextField/TextField.js